module.exports = "<div\n    class=\"kl-steps kl-steps--{direction}\"\n    r-class={{'kl-steps--simple': simple}}\n    style=\"height: {height}px; width: {width}px\"\n    >\n    <!-- {#inc this.$body} -->\n    {#list steps as step}\n    <kl-step title=\"{step.title}\" description=\"{step.description}\" status=\"{step.status}\" key=\"{step.key}\" />\n    {/list}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLSteps/index.html
// module id = 510
// module chunks = 0